// Guard
import { privateGuard } from "@/middlewares/guards";

// Pages
import Territory from "@/pages/Territory";
import Samples from "@/pages/Samples";
import Logbook from "@/pages/Logbook";
import ProfitDetail from "@/pages/ProfitDetail";
import BiologicalCapital from "@/pages/BiologicalCapital";
import AreasList from "@/pages/AreasList";
import AgronomicManagement from "@/pages/AgronomicManagement";
import LogDetail from "@/pages/LogDetail";
import AddLogBook from "@/components/territory/AddLogBook";
import TakePictureLogBook from "@/components/territory/modals/TakePictureLogBook";
import sampleDetail from "@/pages/SampleDetail";
import Profile from "@/pages/Profile";
import Help from "@/pages/Help";
import HelpVideo from "@/components/HelpVideo";
import ClientLayout from "@/layouts/ClientLayout.vue";
import SamplesNotGeo from "@/pages/SamplesNotGeo";
import ProfitsList from "@/pages/ProfitsList.vue";
import ResultList from "@/pages/ResultList";
import ResultDetail from "@/pages/ResultDetail.vue";
import FormProfit from "@/pages/FormProfit.vue";
import Home from "@/pages/Home.vue";
import FormProspect from "@/pages/FormProspect.vue";
import FormCLient from "@/pages/FormCLient.vue";
import AnalysisList from "@/pages/AnalysisList.vue";
import FavoriteClientList from "@/pages/FavoriteClientList.vue";
import Proyects from "@/pages/Proyects.vue";
import ProyectForm from "@/pages/ProyectForm.vue";
import ProjectDetail from "@/pages/ProjectDetail.vue";
import SamplingEndProcess from "@/pages/SamplingEndProcess.vue";
import SamplesGuide from "@/pages/SamplesGuide.vue";

export default [
  {
    path: "/territory",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Territorio",
        component: Territory,
        meta: {
          title: "Territorio",
        },
      },
    ],
  },
  {
    path: "/areasList",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Lista Territorio",
        component: AreasList,
        meta: {
          title: "Lista Territorio",
        },
      },
    ],
  },
  {
    path: "/territory/:id",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Territorio",
        component: Territory,
        meta: {
          title: "Territorio",
        },
      },
    ],
  },
  {
    path: "/samples/:areaId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Muestras",
        component: Samples,
        meta: {
          title: "Muestras",
        },
      },
    ],
  },
  {
    path: "/samples",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Muestras lista",
        component: Samples,
        meta: {
          title: "Muestras lista",
        },
      },
    ],
  },
  {
    path: "/sample-detail/:sampleId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Detalle de muestra",
        component: sampleDetail,
        meta: {
          title: "Detalle de muestra",
        },
      },
    ],
  },
  {
    path: "/agronomic-management/:areaId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Manejo Agrónomico",
        component: AgronomicManagement,
        meta: {
          title: "Manejo Agrónomico",
        },
      },
    ],
  },
  {
    path: "/logbook/:areaId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Bitácora",
        component: Logbook,
        meta: {
          title: "Bitácora",
        },
      },
    ],
  },
  {
    path: "/logbook",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Bitácora",
        component: Logbook,
        meta: {
          title: "Bitácora",
        },
      },
    ],
  },
  {
    path: "/detail-log/:logFieldId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Registro en bitácora",
        component: LogDetail,
        meta: {
          title: "Registro en bitácora",
        },
      },
    ],
  },
  {
    path: "/photoLogbook",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Evidencia",
        component: TakePictureLogBook,
        meta: {
          title: "Evidencia",
        },
      },
    ],
  },
  {
    path: "/profile",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Perfil",
        component: Profile,
        meta: {
          title: "Perfil",
        },
      },
    ],
  },

  {
    path: "/samples-not-geo",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Nueva muestra",
        component: SamplesNotGeo,
        meta: {
          title: "Nueva muestra",
        },
      },
    ],
  },
  {
    path: "/sampling-end/:areaId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Finalizar muestreo",
        component: SamplingEndProcess,
        meta: {
          title: "Finalizar muestreo",
        },
      },
    ],
  },
  {
    path: "/profit-list",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Rentabilizaciones",
        component: ProfitsList,
        meta: {
          title: "Rentabilizaciones",
        },
      },
    ],
  },
  {
    path: "/result-list/:areaId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Resultados de análisis",
        component: ResultList,
        meta: {
          title: "Resultados de análisis",
        },
      },
    ],
  },
  {
    path: "/analysis-list",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Resultados de análisis",
        component: AnalysisList,
        meta: {
          title: "Resultados de análisis",
        },
      },
    ],
  },
  {
    path: "/result-detail/:folio",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Detalle de análisis",
        component: ResultDetail,
        meta: {
          title: "Detalle de análisis",
        },
      },
    ],
  },
  {
    path: "/profit-detail/:profitId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Detalle de rentabilización",
        component: ProfitDetail,
        meta: {
          title: "Detalle de rentabilización",
        },
      },
    ],
  },
  {
    path: "/profit-form",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Nuevo proyecto",
        component: FormProfit,
        meta: {
          title: "Nuevo proyecto",
        },
      },
    ],
  },
  {
    path: "/profit-form-update/:profitId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Actualizar proyecto",
        component: FormProfit,
        meta: {
          title: "Actualizar proyecto",
        },
      },
    ],
  },
  {
    path: "/profit-form-addVersion/:profitVersionId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Agregar versión",
        component: FormProfit,
        meta: {
          title: "Agregar versió",
        },
      },
    ],
  },
  {
    path: "/seller-list/:section",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "",
        component: Home,
        meta: {
          title: "",
        },
      },
    ],
  },
  {
    path: "/prospect-new-form",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Nuevo prospecto",
        component: FormProspect,
        meta: {
          title: "Nuevo prospecto",
        },
      },
    ],
  },
  {
    path: "/prospect-update-form/:id",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Actualizar prospecto",
        component: FormProspect,
        meta: {
          title: "Actualizar prospecto",
        },
      },
    ],
  },
  {
    path: "/client-form/:id",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Actualizar cliente",
        component: FormCLient,
        meta: {
          title: "Actualizar cliente",
        },
      },
    ],
  },
  {
    path: "/favorite",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Favoritos",
        component: FavoriteClientList,
        meta: {
          title: "Favoritos",
        },
      },
    ],
  },
  {
    path: "/proyects-list",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Proyectos",
        component: Proyects,
        meta: {
          title: "Proyectos",
        },
      },
    ],
  },
  {
    path: "/proyect-form/",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Nuevo proyecto",
        component: ProyectForm,
        meta: {
          title: "Nuevo proyecto",
        },
      },
    ],
  },
  {
    path: "/proyect-form/:projectId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Actualizar proyecto",
        component: ProyectForm,
        meta: {
          title: "Actualizar proyecto",
        },
      },
    ],
  },
  {
    path: "/proyect-detail/:projectId",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Detalle proyecto",
        component: ProjectDetail,
        meta: {
          title: "Detalle proyecto",
        },
      },
    ],
  },
  {
    path: "/sample-guide",
    beforeEnter: privateGuard,
    component: ClientLayout,
    children: [
      {
        path: "",
        name: "Sample guide",
        component: SamplesGuide,
        meta: {
          title: "Sample guide",
        },
      },
    ],
  },

  //   {
  //   beforeEnter: privateGuard,
  //   path: "/samples",
  //   component: Samples,
  //   name: "Muestras",
  // },
  //   {
  //   beforeEnter: privateGuard,
  //   path: "/territory/:id",
  //   component: Territory,
  //   name: "Detalle Territorio",
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/photoLogbook",
  //   component: TakePictureLogBook,
  //   name: "Evidencia",
  // },

  // {
  //   beforeEnter: privateGuard,
  //   path: "/samples",
  //   component: Samples,
  //   name: "Muestras",
  // },

  // {
  //   beforeEnter: privateGuard,
  //   path: "/agronomic-management",
  //   component: AgronomicManagement,
  //   name: "Manejo Agrónomico",
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/logbook",
  //   component: Logbook,
  //   name: "Bitácora",
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/biological-capital/:id",
  //   component: BiologicalCapital,
  //   name: "Capital Biológico",
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/detail-log",
  //   component: LogDetail,
  //   name: "Registro en bitácora",
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/sample-detail",
  //   component: sampleDetail,
  //   name: "Detalle de muestra",
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/profile",
  //   name: "Perfil",
  //   component: Profile,
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/help",
  //   name: "Preguntas frecuentes",
  //   component: Help,
  // },
  // {
  //   beforeEnter: privateGuard,
  //   path: "/help-video/:id",
  //   name: "Solena Explore",
  //   component: HelpVideo,
  // },
];
